import { z } from 'zod';
/** Request semantics, not a release number or artifact identity. Legacy is 0. */
export const CLIENT_CONTRACT = 2;
export const CLIENT_CONTRACT_HEADER = 'X-Coach-Client-Contract';
export const clientCompatibilitySchema = z.object({
    schema: z.literal(1),
    revision: z.number().int().positive().max(Number.MAX_SAFE_INTEGER),
    supported: z.array(z.number().int().nonnegative().max(999999)).min(1).max(100),
});
/** Browser WebSocket handshakes cannot set the HTTP contract header. */
export function clientContractWebSocketUrl(input) {
    const url = new URL(input);
    url.searchParams.set('client_contract', String(CLIENT_CONTRACT));
    return url.href;
}
//# sourceMappingURL=client-compatibility.js.map